export const teamMembers = [
  {
    id: 'amit-kumar',
    name: 'Mr. AMIT KUMAR',
    designation: 'Director and Program Implementation Expert',
    qualification: 'MBA Hospital Management, Masters in Public Health (MPH), PG in Guidance & Counselling',
    district: '',
    description: 'Director and program implementation expert with more than 16 years of experience in healthcare and large-scale project implementation with leading funding organisations including WHO, World Bank, USAID, and TISS.',
    image: '/assets/amit-kumar.png'
  },
  {
    id: 'dr-naresh-vashisth',
    name: 'Dr. N.K. VASHISTH',
    designation: 'Subject Matter Expert',
    qualification: 'PhD.; MBA; MPhil (Clinical Psychology)',
    district: '',
    description: 'Have more than 20 yrs of experience, subject matter Expert in the area of Psychology, CBT and Guidance/Counselling.',
    image: null
  },
  {
    id: 'sunita-gusain',
    name: 'Ms. SUNITA GUSAIN',
    designation: 'Director and Program Management Expert',
    qualification: 'Master of Social Work, Postgraduate degree in Sociology',
    district: '',
    description: 'Social development professional with 18+ years of experience in public health, research, rural development, and community-based programs, contributing to maternal and child health, newborn care, HIV/AIDS interventions, and evidence-based program implementation.',
    image: '/assets/ms-sunita-gusain.png'
  },
  {
    id: 'v-n-bhatt',
    name: 'Mr. V.N. BHATT',
    designation: 'Consultant (IT/Finance)',
    qualification: 'MBA (Finance)',
    district: '',
    description: 'Have more than 18 years of experience in the field of IT and finance with some of the top consulting organisations in India.',
    image: null
  },
  {
    id: 'sujata',
    name: 'Ms. SUJATA',
    designation: 'Career Coach and Motivational Counselor',
    qualification: 'Postgraduate in Clinical Psychology, PG Diploma in Guidance & Counselling, one-month psychiatrist training from PGIMS Rohtak',
    district: '',
    description: 'Career coach and motivational counselor with more than 10 years of experience in psychology, career coaching, and psychological issues counseling across Kendriya Vidyalaya schools, Army Public School, and private schools.',
    image: '/assets/ms-sujata.png'
  },
  {
    id: 'shashi-rani',
    name: 'Dr. SHASHI RANI',
    designation: 'State Consultant - Himachal Pradesh',
    qualification: 'BDS; Clinical & Public Health Researcher',
    district: 'HIMACHAL PRADESH',
    description: 'Dr. Rani serves as our State Consultant, bringing profound insights from clinical and public health research to shape impactful regional strategies.',
    image: '/assets/team/dr-shashi-rani.png'
  },
  {
    id: 'state-consultant-up',
    name: 'State Consultant - UP',
    designation: '',
    qualification: '',
    district: '',
    description: '',
    image: null,
    vacant: true
  },
  {
    id: 'poonam-singh',
    name: 'POONAM SINGH',
    designation: 'Workshop Expert',
    qualification: 'Masters in Psychology, Education,PGPDSEHI, B.Ed spl & PGDGC',
    district: 'SAHARANPUR',
    description: 'Poonam brings extensive expertise in psychology and education, specializing in guiding individuals through workshops and specialized counseling with her strong background in psychological methodologies.',
    image: '/assets/team/poonam singh.png'
  },
  {
    id: 'shrishti',
    name: 'SHRISHTI',
    designation: 'Guidance & Counselling Expert',
    qualification: 'Medical & Psychiatric Social work, Guidance & Counselling',
    district: 'SIRMAUR',
    description: 'With specialized medical and psychiatric social work training, Shrishti provides deep, empathetic guidance and counseling for individuals facing complex challenges.',
    image: '/assets/team/Shiristhi.png'
  },
  {
    id: 'amisha-tiwari',
    name: 'AMISHA TIWARI',
    designation: 'Guidance & Counselling Expert',
    qualification: 'Masters in Psychology',
    district: 'SAHARANPUR',
    description: 'Amisha leverages her advanced degree in psychology to deliver expert guidance and counseling, helping individuals navigate their personal and career journeys effectively.',
    image: '/assets/team/amisha.png'
  },
  {
    id: 'ranjana-bagla',
    name: 'Dr. RANJANA BAGLA',
    designation: 'Business Development Manager',
    qualification: 'BDS; Clinical & Public Health Researcher',
    district: 'SAHARANPUR',
    description: 'A clinical and public health researcher by training, Dr. Bagla leads our business development efforts, combining health insights with strategic growth initiatives.',
    image: '/assets/team/dr. ranjna bagla.png'
  },
  {
    id: 'bimla-devi',
    name: 'BIMLA DEVI',
    designation: 'Business Development Manager',
    qualification: 'Masters in Social Work; Community Engagement Expert',
    district: 'SIRMAUR',
    description: 'As a community engagement expert with a master\'s in social work, Bimla fosters strong community relationships and drives business development initiatives.',
    image: '/assets/team/bimla devi.png'
  },
  {
    id: 'khushi-thakur',
    name: 'KHUSHI THAKUR',
    designation: 'Guidance & Counselling Expert',
    qualification: 'Masters in Psychology; Diploma in Counselling & Psychotherapy; Introduction to Human Behavioral Genetics University of Minnesota; The Science of Well-Being Yale University',
    district: 'SOLAN',
    description: 'Khushi integrates insights from human behavioral genetics and the science of well-being to provide holistic counseling and psychotherapy solutions.',
    image: '/assets/team/khushi_thakur.png'
  },
  {
    id: 'naresh-kumar',
    name: 'NARESH KUMAR',
    designation: 'Business Development Manager',
    qualification: 'Masters in Social Work; School Healthy Initiatives Program Expert',
    district: 'SIRMAUR',
    description: 'Naresh specializes in school healthy initiatives, utilizing his social work expertise to drive strategic business development and program execution.',
    image: '/assets/team/naresh kumar.png'
  },
  {
    id: 'sunanda-dey',
    name: 'SUNANDA DEY',
    designation: 'Workshop Expert',
    qualification: 'Mphil. Anthropology; Delhi University, Delhi; MSc. Environmental Science; PG Diploma in Training and Development from Indian Society for Training and Development, Delhi; Worked as',
    district: 'UTTAR PRADESH',
    description: 'With a diverse academic background in anthropology and environmental science, Sunanda excels as a Workshop Expert, drawing from extensive training and development experience.',
    image: '/assets/team/sunanda dey.png'
  },
  {
    id: 'rajni-khoond',
    name: 'RAJNI KHOOND',
    designation: 'Business Development Manager',
    qualification: 'MBA(Rural Development); Masters in Social work; Experience in Collected primary data for the National Mental Health Survey (NIMHANS-Bengaluru) in Himachal Pradesh (Department of Psychiatry, IGMC Shimla)',
    district: 'SOLAN',
    description: 'Rajni brings critical data-driven insights from her work on national mental health surveys to our business development efforts, backed by her MBA and social work background.',
    image: '/assets/team/rajni khoond.png'
  }
];
